export default [
  {
    path: '/metaplanet_presale',
    name: 'PresaleView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/PresaleView.vue'
      ),
    meta: { title: 'Presale', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_coinsale',
    name: 'CoinsaleView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/CoinsaleView.vue'
      ),
    meta: { title: 'Coinsale', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_token',
    name: 'TokenView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/TokenView.vue'
      ),
    meta: { title: 'Token', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_oldtoken',
    name: 'OldTokenView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/OldTokenView.vue'
      ),
    meta: { title: 'Old Token', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_probit',
    name: 'ProbitView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/ProbitView.vue'
      ),
    meta: { title: 'Probit', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_probit_deposit',
    name: 'ProbitDepositView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/ProbitDepositView.vue'
      ),
    meta: { title: 'Probit Deposit', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_probit_order_history',
    name: 'ProbitOrderHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/ProbitOrderHistoryView.vue'
      ),
    meta: { title: 'Probit Order History', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_lbank',
    name: 'LBankView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/LBankView.vue'
      ),
    meta: { title: 'LBank', group: 'metaplanet-token' },
  },
  {
    path: '/lbank_monitor',
    name: 'LBankMonitorView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/LBankMonitorView.vue'
      ),
    meta: { title: 'LBank Monitor', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_lbank_order_history',
    name: 'LBankOrderHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/LBankOrderHistoryView.vue'
      ),
    meta: { title: 'LBank Order History', group: 'metaplanet-token' },
  },
  {
    path: '/lbank_trades',
    name: 'LBankTradesView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/LBankTradesView.vue'
      ),
    meta: { title: 'LBank Trades', group: 'metaplanet-token' },
  },
  {
    path: '/lbank_losses',
    name: 'LBankLossesView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/LBankLossesView.vue'
      ),
    meta: { title: 'LBank Losses', group: 'metaplanet-token' },
  },
  {
    path: '/lbank_trade_logs',
    name: 'LBankTradeLogsView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/LBankTradeLogsView.vue'
      ),
    meta: { title: 'LBank Trade Logs', group: 'metaplanet-token' },
  },
  {
    path: '/lbank_asset_changes',
    name: 'LBankAssetChangesView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/LBankAssetChangesView.vue'
      ),
    meta: { title: 'LBank Asset Changes', group: 'metaplanet-token' },
  },
  {
    path: '/metaplanet_balance_probit_history',
    name: 'BalanceHistoryProbitView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-token" */ '@/views/MetaplanetToken/BalanceHistoryProbitView.vue'
      ),
    meta: { title: 'Probit Balance History', group: 'metaplanet-token' },
  },
]
